import React, { useState, useEffect, useRef } from 'react';

const videos = [
  { id: 'DXI8kXnjz2A' },
  { id: 'EOV5vQkZVp8' },
  { id: 'TWiGN19P_uc' },
  // { id: 'DwY5eVqbbgc' },
];

const styles = `
.video-carousel-section {
  padding: 4rem 1rem;
  text-align: center;
  font-family: 'Titillium Web', sans-serif;
  background: #fff;
}
.video-carousel-section h2 {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #111;
  line-height: 1.1;
}
.video-carousel-section p {
  margin-bottom: 4.5rem;
  color: #555;
  font-size: 1.3rem;
  line-height: 1.6;
}
.video-carousel {
  position: relative;
  width: 100%;
  max-width: 1000px;
  height: 520px;
  margin: 0 auto;
  border-radius: 1rem;
  overflow: hidden;
  background: #000;
}
.video-carousel__slide {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-carousel__slide--active {
  opacity: 1;
}
.video-carousel__thumbnail {
  width: 100%;
  height: 520px;
  cursor: pointer;
  display: block;
  object-fit: cover;
}
.video-carousel__play-overlay {
  position: absolute;
  font-size: 3rem;
  color: rgba(255,255,255,0.8);
  cursor: pointer;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.video-carousel__iframe {
  width: 100%;
  height: 520px;
  border: none;
}
.video-carousel__dots {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 3rem;
}
.video-carousel__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #aaa;
  transition: all 0.3s ease;
  cursor: pointer;
}
.video-carousel__dot--active {
  width: 60px;
  height: 12px;
  border-radius: 20px;
  background: #1e3a8a;
}

@media (max-width: 768px) {
  .video-carousel-section h2 {
    font-size: 2rem;
    margin-bottom: 0.9rem;
  }
  .video-carousel-section p {
    font-size: 1rem;
    margin-bottom: 2.4rem;
    line-height: 1.5;
    padding: 0 1rem;
  }
  .video-carousel {
    max-width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
    border-radius: 0.75rem;
  }
  .video-carousel__thumbnail,
  .video-carousel__iframe {
    width: 100%;
    height: 100%;
    border-radius: 0.75rem;
  }
  .video-carousel__play-overlay {
    font-size: 2.4rem;
  }
  .video-carousel__dots {
    margin-top: 2rem;
  }
}
`;

export default function Videocorousel() {
  const [current, setCurrent] = useState(0);
  const [playingIndex, setPlayingIndex] = useState(null);
  const timeoutRef = useRef(null);
  const length = videos.length;

  const nextSlide = () => {
    setCurrent(prev => (prev === length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    if (playingIndex === null) {
      timeoutRef.current = setTimeout(nextSlide, 4000);
    }
    return () => clearTimeout(timeoutRef.current);
  }, [current, playingIndex]);

  const goToSlide = idx => {
    clearTimeout(timeoutRef.current);
    setPlayingIndex(null);
    setCurrent(idx);
  };

  const handleThumbnailClick = idx => {
    clearTimeout(timeoutRef.current);
    setPlayingIndex(idx);
    setCurrent(idx);
  };

  return (
    <>
      <style>{styles}</style>
      <section className="video-carousel-section">
        <h2>Latest Videos</h2>
        <p>
          Insights, Tips & Updates from the World of Credit Cards – Straight from Card Academy
        </p>

        <div className="video-carousel">
  <div className="video-carousel__slide video-carousel__slide--active">
    {playingIndex === current ? (
      <iframe
        className="video-carousel__iframe"
        src={`https://www.youtube.com/embed/${videos[current].id}?autoplay=1`}
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={`Video ${current + 1}`}
      />
    ) : (
      <>
        <img
          className="video-carousel__thumbnail"
          src={`https://img.youtube.com/vi/${videos[current].id}/maxresdefault.jpg`}
          alt={`Video ${current + 1} thumbnail`}
          onClick={() => handleThumbnailClick(current)}
        />
        <div
          className="video-carousel__play-overlay"
          onClick={() => handleThumbnailClick(current)}
        >
          ▶
        </div>
      </>
    )}
  </div>
</div>


        <div className="video-carousel__dots">
          {videos.map((_, idx) => (
            <span
              key={idx}
              className={
                'video-carousel__dot' +
                (idx === current ? ' video-carousel__dot--active' : '')
              }
              onClick={() => goToSlide(idx)}
            />
          ))}
        </div>
      </section>
    </>
  );
}
